import React, { Component } from 'react';
import {Subtopic, TextHolder, Footer,Highchartscomponent, Button} from '../../Components/contentHolders/contentHolders.js';
import './styles.css';



import Highcharts from 'highcharts';

Highcharts.setOptions({
colors: ['#660066', '#800080', '#be29ec', '#d896ff', '#efbbff',
    '#FDB9C8', '#DE6FA1', '#FB607F', '#DE3163', '#F81894']
});

const survey6 = {
  chart: {
      type: 'column'
  },
  title: {
      text: ''
  },
  xAxis: {
      categories: ['VC/Investor', 'Founder', 'Community builder']
  },
  yAxis: {
      min: 0,
      title: {
          text: '% of responses'
      }
  },
  tooltip: {
      pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.percentage:.0f}%)<br/>',
      shared: true
  },
  plotOptions: {
      column: {
          stacking: 'percent'
      }
  },
  series: [{
      name: '6 or more',
      data: [12, 16, 0]
    },
      {
      name: '4 to 5',
      data: [32, 16, 19]
    },
      {
      name: '2 to 3',
      data: [48, 36, 44]
    },
      {
      name: '1',
      data: [4, 18, 19]
    },
      {
      name: 'Not sure / prefer not to respond',
      data: [4, 13, 19]
      }]
}


const survey7 = {
  chart: {
        type: 'bar'
    },
    title: {
        text: ''
    },
    xAxis: {
        categories: ['Community builder', 'Founder', 'VC/Investor']
    },
    yAxis: {
        min: 0,
        title: {
            text: '% of responses by population type'
        }
    },
    legend: {
        reversed: true
    },
    plotOptions: {
        series: {
            stacking: 'percent'
        }
    },
    series: [{
        name: 'Not sure',
        data: [6, 2, 0]
    },{
        name: 'It is not discussed',
        data: [31, 54, 67]
    },{
        name: 'It is somewhat of an issue',
        data: [50, 37, 29]
    },{
        name: 'It is a major issue',
        data: [13, 7, 4]
    }]
}



export class ChapterFiftyFive extends Component {

  render() {
    return (

      <section className="Content">
        <div className="content-holder">
        <div className="content-holder-inner fade">


        <Subtopic subtopicNumber={ this.props.number } subtopicTitle={ this.props.name } >

        {""}
        </Subtopic>


          <TextHolder text="Visit any startup in SEA today, and chances are it is a mini-United Nations. Among the staff, there will be faces from different countries around the region as well as from further out; Europeans, Americans, Russians, and others will be well-represented." />
          <TextHolder text="Why this great variety? Many foreign professionals with special technical skills have been hired to work in SEA. Others are attracted by the national incentives to found their companies in the region. Yet others used to be former staff of multinational corporations working in SEA offices, but elect to settle here for family reasons or because they see the business potential in the digital economy." />
          <TextHolder text="" />

          <Highchartscomponent chartsText="Approximately how many ethnicities are represented in your workforce?"
                    options={survey6} source="Source: 2018 State of SE Asian Tech Survey" />
                    <TextHolder text="" />

          <TextHolder text="This diversity shows up in the survey findings. Most respondents said that at least two to three ethnicities were represented on their company’s staff. Investors has the most diverse staffs, with 92 percent of respondents saying that multiple ethnicities were represented. Like gender diversity, ethnic diversity is not widely discussed within the SEA tech ecosystem; however, perhaps that is because most offices already are ethnically diverse."/>
          <TextHolder text="Interestingly, while community builders have the least ethnically diverse workforce, they were also most likely to acknowledge that the lack of ethnic diversity is an issue. It seems likely, then, that community builders may take action on it in the near future."/>
          <TextHolder text="" />

          <Highchartscomponent chartsText="How do you think ethnic diversity is viewed in the SEA tech industry?"
                      options={survey7} source="Source: 2018 State of SE Asian Tech Survey" />

          <Button next={ this.props.next } buttonText= { this.props.buttonText } />
          <Footer />
          </div>
        </div>
      </section>

    );
  }
}



// WEBPACK FOOTER //
// ./src/Containers/Content/55.js